import { RootState } from '@debbie/cortex/dist/reducer.js'
import Billings from '@debbie/iris/dist/components/economy/Billings.js'
import {
  Content,
  PageBase,
  Panel,
  TopNav,
} from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useSelector } from 'react-redux'

const Billing = () => {
  const lang = useSelector((s: RootState) => s.lang)
  const selectedCreditor = useSelector((s: RootState) => s.selectedCreditor)

  return (
    <>
      <TopNav />
      <Content withSubMenu>
        <PageBase>
          <Panel header={lang.billing.bills}>
            <Billings creditorId={selectedCreditor} />
          </Panel>
        </PageBase>
      </Content>
    </>
  )
}

export default Billing
